import { getCurrentPathname } from '@modules/Core';
import _findIndex from 'lodash/findIndex';
import { TABS_OPTIONS } from './constants';

export const getDefaultParams = () => ({ view: getCurrentPathname() });

export const getActiveTabIndex = (key) => _findIndex(TABS_OPTIONS, { key });
